<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles">
    <h2 class="modal-title">Item da FCI</h2>
    <span class="modal-subtitle">Edite os dados do produto e informe o Código FCI</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12 mb-2">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Produto</mat-label>
          <input matInput [(ngModel)]="buscaProduto" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onBuscaChange()" [matAutocomplete]="autoProduto" placeholder="Pesquisar produto…" />
          <mat-autocomplete #autoProduto="matAutocomplete">
            @for (p of resultadosBusca; track p.idProduto) {
            <mat-option [value]="p.descricao" (onSelectionChange)="selecionarProduto(p)">
              {{ p.descricao }} <small>· {{ p.codigoSku }}</small>
            </mat-option>
            }
          </mat-autocomplete>
          <mat-icon matSuffix>search</mat-icon>
          <mat-hint>Pesquise o produto para carregar automaticamente os demais dados</mat-hint>
        </mat-form-field>
      </div>

      @if (produtoSelecionado) {
      <!-- Dados do produto — somente leitura. Nunca editáveis: emitir a FCI com dados
           diferentes do cadastro real do produto geraria divergência no documento fiscal. -->
      <div class="col-12">
        <div class="produto-readonly">
          <div class="produto-readonly__item produto-readonly__item--full">
            <small>Descrição</small>
            <span>{{ produtoSelecionado.descricao }}</span>
          </div>
          <div class="produto-readonly__item">
            <small>Código</small>
            <span class="mono">{{ produtoSelecionado.codigoSku || '—' }}</span>
          </div>
          <div class="produto-readonly__item">
            <small>NCM</small>
            <span class="mono">{{ produtoSelecionado.ncm || '—' }}</span>
          </div>
          <div class="produto-readonly__item">
            <small>UN</small>
            <span>{{ produtoSelecionado.unidade || '—' }}</span>
          </div>
          <div class="produto-readonly__item">
            <small>GTIN</small>
            <span class="mono">{{ produtoSelecionado.gtin || '—' }}</span>
          </div>
        </div>
      </div>
      }


      <div class="col-12 col-sm-6 mb-2 mt-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Valor saída</mat-label>
          <input matInput type="text" inputmode="decimal" [currencyMask]="moneyMask" formControlName="valorSaida" />
          @if (form.get('valorSaida')?.hasError('required') || form.get('valorSaida')?.hasError('min')) {
          <mat-error>Informe o valor de saída</mat-error>
          }
          <mat-hint>Não altera o cadastro do produto — vale só para esta FCI</mat-hint>
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6 mb-2 mt-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Valor parcela</mat-label>
          <input matInput type="text" inputmode="decimal" [currencyMask]="moneyMask" formControlName="valorParcela" />
          @if (form.get('valorParcela')?.hasError('parcelaMaiorQueSaida')) {
          <mat-error>A parcela não pode superar o valor de saída</mat-error>
          } @else if (form.get('valorParcela')?.hasError('required') || form.get('valorParcela')?.hasError('min')) {
          <mat-error>Informe o valor da parcela importada</mat-error>
          }
          <mat-hint>Valor dos insumos importados</mat-hint>
        </mat-form-field>
      </div>

      <div class="col-12 mb-2">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Conteúdo importação %</mat-label>
          <input matInput type="text" inputmode="decimal" [currencyMask]="percentMask"
            formControlName="percentualConteudoImportacao" />
          @if (form.get('percentualConteudoImportacao')?.hasError('required') ||
          form.get('percentualConteudoImportacao')?.hasError('min')) {
          <mat-error>Informe o conteúdo de importação</mat-error>
          } @else if (form.get('percentualConteudoImportacao')?.hasError('max')) {
          <mat-error>O percentual não pode superar 100%</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 mb-2">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Código FCI</mat-label>
          <input matInput formControlName="codigoFci" class="mono" [mask]="masks.nfci" [patterns]="codigoFciPatterns"
            [dropSpecialCharacters]="false" (input)="onCodigoFciInput($event)"
            placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX" />
          @if (form.get('codigoFci')?.hasError('codigoFciInvalido')) {
          <mat-error>Formato inválido — padrão nFCI: 8-4-4-4-12 (A–F, 0–9)</mat-error>
          } @else if (codigoFciValido) {
          <mat-hint class="hint-success">
            <mat-icon inline>check_circle</mat-icon> Código válido · gera a tag <b>nFCI</b> do XML
          </mat-hint>
          } @else {
          <mat-hint>Obtido após envio ao SEFAZ; opcional</mat-hint>
          }
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  @if (form.invalid && form.touched) {
  <span class="field-error me-auto">Revise os campos destacados</span>
  }
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="salvar()">Salvar</button>
</mat-dialog-actions>